import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHome,
    faSearch,
    faEllipsisH,
    faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
import {
    Breadcrumb,
    ButtonGroup,
    Button,
    InputGroup,
    Form,
    Card,
    Table,
    Dropdown,
    Spinner,
} from "@themesberg/react-bootstrap";
import { useHistory } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import moment from "moment-timezone";
export default function ApprovalUserPage() {
    const history = useHistory();
    const [userList, setUserList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [userRole, setUserRole] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            alert("Sesi kamu telah berakhir, silakan login kembali.");
            history.push("/login");
            return;
        }

        try {
            const decoded = jwtDecode(token);

            if (decoded.exp * 1000 < Date.now()) {
                localStorage.removeItem("token");
                alert("Token kamu sudah kedaluwarsa, silakan login ulang.");
                history.push("/login");
                return;
            }

            setUserRole(decoded.role);
        } catch (err) {
            console.error("Token invalid:", err);
            localStorage.removeItem("token");
            history.push("/login");
        }
    }, [history]);

    const fetchUser = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                alert("Sesi kamu telah berakhir, silakan login kembali.");
                history.push("/login");
                return;
            }
            const response = await fetch(`${process.env.REACT_APP_API_URL}/user`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await response.json();
            setUserList(data);
        } catch (error) {
            console.error("Gagal mengambil data user:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleApprove = async (id, nama, approval) => {
        const yakin = window.confirm(`Apakah kamu yakin ingin meng approve user "${nama}"?`);
        if (!yakin) return;

        const token = localStorage.getItem("token");
        const newApproval = !approval;

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/approval-user/${id}`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ approval: newApproval }),
            });

            if (response.ok) {
                alert("User berhasil di approve");
                fetchUser();
            } else {
                const text = await response.text();
                alert(`Gagal meng approve user: ${text}`);
            }
        } catch (error) {
            console.error("Gagal meng approve user:", error);
            alert("Terjadi kesalahan saat meng approve user ");
        }
    };

    useEffect(() => {
        fetchUser();
    }, []);

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <Breadcrumb className="d-none d-md-inline-block breadcrumb-dark breadcrumb-transparent">
                        <Breadcrumb.Item>
                            <FontAwesomeIcon icon={faHome} />
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>Volt</Breadcrumb.Item>
                        <Breadcrumb.Item active>Approval User</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4>Daftar User</h4>
                    <p className="mb-0">Data User</p>
                </div>
            </div>

            <div className="table-settings mb-4">
                <InputGroup style={{ maxWidth: "400px" }}>
                    <InputGroup.Text>
                        <FontAwesomeIcon icon={faSearch} />
                    </InputGroup.Text>
                    <Form.Control type="text" placeholder="Cari user..." />
                </InputGroup>
            </div>

            <Card border="light" className="table-wrapper table-responsive shadow-sm">
                <Card.Body>
                    {loading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" />
                        </div>
                    ) : userList.length === 0 ? (
                        <p className="text-center mt-4">Tidak ada data user.</p>
                    ) : (
                        <Table hover className="user-table align-items-center">
                            <thead>
                                <tr>
                                    <th>Nama</th>
                                    <th>Username</th>
                                    <th>Email</th>
                                    <th>Alamat</th>
                                    <th>Role</th>
                                    <th>No Hp</th>
                                    <th>Tanggal Lahir</th>
                                    <th>Approval</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userList.map((user) => (
                                    <tr key={user.id}>
                                        <td>{user.nama}</td>
                                        <td>{user.username}</td>
                                        <td>{user.email?.String || "-"}</td>
                                        <td>{user.alamat}</td>
                                        <td>{user.role}</td>
                                        <td>{user.nohp}</td>
                                        <td>{moment(user.tanggal_lahir).format("YYYY-MM-DD")}</td>
                                        <td>{user.approval ? "Disetujui" : "Belum disetujui"}</td>
                                        <td>
                                            <Dropdown as={ButtonGroup}>
                                                <Dropdown.Toggle
                                                    as={Button}
                                                    split
                                                    variant="link"
                                                    className="text-dark m-0 p-0"
                                                >
                                                    <span className="icon icon-sm">
                                                        <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
                                                    </span>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {userRole === "admin" && (
                                                        <>
                                                            <Dropdown.Item
                                                                onClick={() => handleApprove(user.id, user.nama, user.approval)}
                                                            >
                                                                <FontAwesomeIcon icon={faThumbsUp} className="me-2" />  {user.approval ? "Belum disetujui" : "Disetujui"}
                                                            </Dropdown.Item>
                                                        </>
                                                    )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </Card.Body>
            </Card>
        </>
    );
}
